import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative bg-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 w-1/2 bg-gray-50" })
], -1)
const _hoisted_3 = { class: "relative max-w-7xl mx-auto lg:grid lg:grid-cols-5" }
const _hoisted_4 = { class: "bg-gray-50 py-16 px-4 sm:px-6 lg:col-span-2 lg:px-8 lg:py-24 xl:pr-12" }
const _hoisted_5 = { class: "max-w-lg mx-auto" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl" }, "Get in touch", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 text-lg leading-6 text-gray-500" }, [
  /*#__PURE__*/_createElementVNode("figcaption", { class: "mt-10 mb-4 flex gap-x-6" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://res.cloudinary.com/millsit/image/upload/v1678465983/TOT/topotobago/silja_rc1fsd.jpg",
      alt: "",
      class: "h-20 w-20 flex-none rounded-full bg-gray-50"
    }),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold text-gray-900 mt-4" }, "Silja Heinze"),
      /*#__PURE__*/_createElementVNode("div", { class: "text-sm leading-6 text-gray-600" }, "Onsite Manager")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" We are happy to answer your questions. For any further information or inquiries, please contact the local host "),
    /*#__PURE__*/_createElementVNode("span", { class: "italic" }, "Silja Heinze"),
    /*#__PURE__*/_createTextVNode(" using the form below. ")
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" If you need immediate answers to your questions or if your message concerns last minute changes to your arrival at the villa, it is best to phone Silja on her cell at "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "tel:+18686870121",
      class: "text-black"
    }, "(+1) 868-687-0121"),
    /*#__PURE__*/_createTextVNode(" or on "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://api.whatsapp.com/send?phone=18686870121",
      class: "text-black",
      target: "_blank"
    }, "WhatsApp"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_8 = { class: "mt-8 text-base text-gray-500" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("dt", { class: "sr-only" }, "Address"),
  /*#__PURE__*/_createElementVNode("dd", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Arnos Vale Rd, Plymouth, Trinidad & Tobago")
  ])
], -1)
const _hoisted_10 = { class: "mt-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", { class: "sr-only" }, "Phone number", -1)
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, " (+1) 868-687-0121 ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "(WhatsApp)", -1)
const _hoisted_15 = { class: "mt-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("dt", { class: "sr-only" }, "Email", -1)
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, " host@topotobago.com ", -1)
const _hoisted_19 = { class: "bg-white py-16 px-4 sm:px-6 lg:col-span-3 lg:py-24 lg:px-8 xl:pl-12" }
const _hoisted_20 = { class: "max-w-lg mx-auto lg:max-w-none" }
const _hoisted_21 = ["onSubmit"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "full-name",
  class: "sr-only"
}, "Full name", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "sr-only"
}, "Email", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "sr-only"
}, "Phone", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "country",
  class: "sr-only"
}, "Country", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "-- Select Country --", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "Trinidad & Tobago" }, "Trinidad & Tobago", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "---" }, "---", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "Afganistan" }, "Afghanistan", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "Albania" }, "Albania", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "Algeria" }, "Algeria", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "American Samoa" }, "American Samoa", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "Andorra" }, "Andorra", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "Angola" }, "Angola", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "Anguilla" }, "Anguilla", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "Antigua & Barbuda" }, "Antigua & Barbuda", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", { value: "Argentina" }, "Argentina", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", { value: "Armenia" }, "Armenia", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: "Aruba" }, "Aruba", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", { value: "Australia" }, "Australia", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", { value: "Austria" }, "Austria", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("option", { value: "Azerbaijan" }, "Azerbaijan", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: "Bahamas" }, "Bahamas", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", { value: "Bahrain" }, "Bahrain", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", { value: "Bangladesh" }, "Bangladesh", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", { value: "Barbados" }, "Barbados", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: "Belarus" }, "Belarus", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("option", { value: "Belgium" }, "Belgium", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("option", { value: "Belize" }, "Belize", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("option", { value: "Benin" }, "Benin", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("option", { value: "Bermuda" }, "Bermuda", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", { value: "Bhutan" }, "Bhutan", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("option", { value: "Bolivia" }, "Bolivia", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("option", { value: "Bonaire" }, "Bonaire", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("option", { value: "Bosnia & Herzegovina" }, "Bosnia & Herzegovina", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", { value: "Botswana" }, "Botswana", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", { value: "Brazil" }, "Brazil", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", { value: "British Indian Ocean Ter" }, "British Indian Ocean Ter", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("option", { value: "Brunei" }, "Brunei", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("option", { value: "Bulgaria" }, "Bulgaria", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("option", { value: "Burkina Faso" }, "Burkina Faso", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("option", { value: "Burundi" }, "Burundi", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("option", { value: "Cambodia" }, "Cambodia", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("option", { value: "Cameroon" }, "Cameroon", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("option", { value: "Canada" }, "Canada", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("option", { value: "Canary Islands" }, "Canary Islands", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("option", { value: "Cape Verde" }, "Cape Verde", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("option", { value: "Cayman Islands" }, "Cayman Islands", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("option", { value: "Central African Republic" }, "Central African Republic", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("option", { value: "Chad" }, "Chad", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("option", { value: "Channel Islands" }, "Channel Islands", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("option", { value: "Chile" }, "Chile", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("option", { value: "China" }, "China", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("option", { value: "Christmas Island" }, "Christmas Island", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("option", { value: "Cocos Island" }, "Cocos Island", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("option", { value: "Colombia" }, "Colombia", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("option", { value: "Comoros" }, "Comoros", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("option", { value: "Congo" }, "Congo", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("option", { value: "Cook Islands" }, "Cook Islands", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("option", { value: "Costa Rica" }, "Costa Rica", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("option", { value: "Cote DIvoire" }, "Cote DIvoire", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("option", { value: "Croatia" }, "Croatia", -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("option", { value: "Cuba" }, "Cuba", -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("option", { value: "Curaco" }, "Curacao", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("option", { value: "Cyprus" }, "Cyprus", -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("option", { value: "Czech Republic" }, "Czech Republic", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("option", { value: "Denmark" }, "Denmark", -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("option", { value: "Djibouti" }, "Djibouti", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("option", { value: "Dominica" }, "Dominica", -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("option", { value: "Dominican Republic" }, "Dominican Republic", -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("option", { value: "East Timor" }, "East Timor", -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("option", { value: "Ecuador" }, "Ecuador", -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("option", { value: "Egypt" }, "Egypt", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("option", { value: "El Salvador" }, "El Salvador", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("option", { value: "Equatorial Guinea" }, "Equatorial Guinea", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("option", { value: "Eritrea" }, "Eritrea", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("option", { value: "Estonia" }, "Estonia", -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("option", { value: "Ethiopia" }, "Ethiopia", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("option", { value: "Falkland Islands" }, "Falkland Islands", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("option", { value: "Faroe Islands" }, "Faroe Islands", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("option", { value: "Fiji" }, "Fiji", -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("option", { value: "Finland" }, "Finland", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("option", { value: "France" }, "France", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("option", { value: "French Guiana" }, "French Guiana", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("option", { value: "French Polynesia" }, "French Polynesia", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("option", { value: "French Southern Ter" }, "French Southern Ter", -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("option", { value: "Gabon" }, "Gabon", -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("option", { value: "Gambia" }, "Gambia", -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("option", { value: "Georgia" }, "Georgia", -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("option", { value: "Germany" }, "Germany", -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("option", { value: "Ghana" }, "Ghana", -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("option", { value: "Gibraltar" }, "Gibraltar", -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("option", { value: "Great Britain" }, "Great Britain", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("option", { value: "Greece" }, "Greece", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("option", { value: "Greenland" }, "Greenland", -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("option", { value: "Grenada" }, "Grenada", -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("option", { value: "Guadeloupe" }, "Guadeloupe", -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("option", { value: "Guam" }, "Guam", -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("option", { value: "Guatemala" }, "Guatemala", -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("option", { value: "Guinea" }, "Guinea", -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("option", { value: "Guyana" }, "Guyana", -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("option", { value: "Haiti" }, "Haiti", -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("option", { value: "Hawaii" }, "Hawaii", -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("option", { value: "Honduras" }, "Honduras", -1)
const _hoisted_125 = /*#__PURE__*/_createElementVNode("option", { value: "Hong Kong" }, "Hong Kong", -1)
const _hoisted_126 = /*#__PURE__*/_createElementVNode("option", { value: "Hungary" }, "Hungary", -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("option", { value: "Iceland" }, "Iceland", -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("option", { value: "Indonesia" }, "Indonesia", -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("option", { value: "India" }, "India", -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("option", { value: "Iran" }, "Iran", -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("option", { value: "Iraq" }, "Iraq", -1)
const _hoisted_132 = /*#__PURE__*/_createElementVNode("option", { value: "Ireland" }, "Ireland", -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("option", { value: "Isle of Man" }, "Isle of Man", -1)
const _hoisted_134 = /*#__PURE__*/_createElementVNode("option", { value: "Israel" }, "Israel", -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("option", { value: "Italy" }, "Italy", -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("option", { value: "Jamaica" }, "Jamaica", -1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("option", { value: "Japan" }, "Japan", -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("option", { value: "Jordan" }, "Jordan", -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("option", { value: "Kazakhstan" }, "Kazakhstan", -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("option", { value: "Kenya" }, "Kenya", -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("option", { value: "Kiribati" }, "Kiribati", -1)
const _hoisted_142 = /*#__PURE__*/_createElementVNode("option", { value: "Korea North" }, "Korea North", -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("option", { value: "Korea Sout" }, "Korea South", -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("option", { value: "Kuwait" }, "Kuwait", -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("option", { value: "Kyrgyzstan" }, "Kyrgyzstan", -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("option", { value: "Laos" }, "Laos", -1)
const _hoisted_147 = /*#__PURE__*/_createElementVNode("option", { value: "Latvia" }, "Latvia", -1)
const _hoisted_148 = /*#__PURE__*/_createElementVNode("option", { value: "Lebanon" }, "Lebanon", -1)
const _hoisted_149 = /*#__PURE__*/_createElementVNode("option", { value: "Lesotho" }, "Lesotho", -1)
const _hoisted_150 = /*#__PURE__*/_createElementVNode("option", { value: "Liberia" }, "Liberia", -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("option", { value: "Libya" }, "Libya", -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("option", { value: "Liechtenstein" }, "Liechtenstein", -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("option", { value: "Lithuania" }, "Lithuania", -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("option", { value: "Luxembourg" }, "Luxembourg", -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("option", { value: "Macau" }, "Macau", -1)
const _hoisted_156 = /*#__PURE__*/_createElementVNode("option", { value: "Macedonia" }, "Macedonia", -1)
const _hoisted_157 = /*#__PURE__*/_createElementVNode("option", { value: "Madagascar" }, "Madagascar", -1)
const _hoisted_158 = /*#__PURE__*/_createElementVNode("option", { value: "Malaysia" }, "Malaysia", -1)
const _hoisted_159 = /*#__PURE__*/_createElementVNode("option", { value: "Malawi" }, "Malawi", -1)
const _hoisted_160 = /*#__PURE__*/_createElementVNode("option", { value: "Maldives" }, "Maldives", -1)
const _hoisted_161 = /*#__PURE__*/_createElementVNode("option", { value: "Mali" }, "Mali", -1)
const _hoisted_162 = /*#__PURE__*/_createElementVNode("option", { value: "Malta" }, "Malta", -1)
const _hoisted_163 = /*#__PURE__*/_createElementVNode("option", { value: "Marshall Islands" }, "Marshall Islands", -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("option", { value: "Martinique" }, "Martinique", -1)
const _hoisted_165 = /*#__PURE__*/_createElementVNode("option", { value: "Mauritania" }, "Mauritania", -1)
const _hoisted_166 = /*#__PURE__*/_createElementVNode("option", { value: "Mauritius" }, "Mauritius", -1)
const _hoisted_167 = /*#__PURE__*/_createElementVNode("option", { value: "Mayotte" }, "Mayotte", -1)
const _hoisted_168 = /*#__PURE__*/_createElementVNode("option", { value: "Mexico" }, "Mexico", -1)
const _hoisted_169 = /*#__PURE__*/_createElementVNode("option", { value: "Midway Islands" }, "Midway Islands", -1)
const _hoisted_170 = /*#__PURE__*/_createElementVNode("option", { value: "Moldova" }, "Moldova", -1)
const _hoisted_171 = /*#__PURE__*/_createElementVNode("option", { value: "Monaco" }, "Monaco", -1)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("option", { value: "Mongolia" }, "Mongolia", -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("option", { value: "Montserrat" }, "Montserrat", -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("option", { value: "Morocco" }, "Morocco", -1)
const _hoisted_175 = /*#__PURE__*/_createElementVNode("option", { value: "Mozambique" }, "Mozambique", -1)
const _hoisted_176 = /*#__PURE__*/_createElementVNode("option", { value: "Myanmar" }, "Myanmar", -1)
const _hoisted_177 = /*#__PURE__*/_createElementVNode("option", { value: "Nambia" }, "Nambia", -1)
const _hoisted_178 = /*#__PURE__*/_createElementVNode("option", { value: "Nauru" }, "Nauru", -1)
const _hoisted_179 = /*#__PURE__*/_createElementVNode("option", { value: "Nepal" }, "Nepal", -1)
const _hoisted_180 = /*#__PURE__*/_createElementVNode("option", { value: "Netherland Antilles" }, "Netherland Antilles", -1)
const _hoisted_181 = /*#__PURE__*/_createElementVNode("option", { value: "Netherlands" }, "Netherlands (Holland, Europe)", -1)
const _hoisted_182 = /*#__PURE__*/_createElementVNode("option", { value: "Nevis" }, "Nevis", -1)
const _hoisted_183 = /*#__PURE__*/_createElementVNode("option", { value: "New Caledonia" }, "New Caledonia", -1)
const _hoisted_184 = /*#__PURE__*/_createElementVNode("option", { value: "New Zealand" }, "New Zealand", -1)
const _hoisted_185 = /*#__PURE__*/_createElementVNode("option", { value: "Nicaragua" }, "Nicaragua", -1)
const _hoisted_186 = /*#__PURE__*/_createElementVNode("option", { value: "Niger" }, "Niger", -1)
const _hoisted_187 = /*#__PURE__*/_createElementVNode("option", { value: "Nigeria" }, "Nigeria", -1)
const _hoisted_188 = /*#__PURE__*/_createElementVNode("option", { value: "Niue" }, "Niue", -1)
const _hoisted_189 = /*#__PURE__*/_createElementVNode("option", { value: "Norfolk Island" }, "Norfolk Island", -1)
const _hoisted_190 = /*#__PURE__*/_createElementVNode("option", { value: "Norway" }, "Norway", -1)
const _hoisted_191 = /*#__PURE__*/_createElementVNode("option", { value: "Oman" }, "Oman", -1)
const _hoisted_192 = /*#__PURE__*/_createElementVNode("option", { value: "Pakistan" }, "Pakistan", -1)
const _hoisted_193 = /*#__PURE__*/_createElementVNode("option", { value: "Palau Island" }, "Palau Island", -1)
const _hoisted_194 = /*#__PURE__*/_createElementVNode("option", { value: "Palestine" }, "Palestine", -1)
const _hoisted_195 = /*#__PURE__*/_createElementVNode("option", { value: "Panama" }, "Panama", -1)
const _hoisted_196 = /*#__PURE__*/_createElementVNode("option", { value: "Papua New Guinea" }, "Papua New Guinea", -1)
const _hoisted_197 = /*#__PURE__*/_createElementVNode("option", { value: "Paraguay" }, "Paraguay", -1)
const _hoisted_198 = /*#__PURE__*/_createElementVNode("option", { value: "Peru" }, "Peru", -1)
const _hoisted_199 = /*#__PURE__*/_createElementVNode("option", { value: "Phillipines" }, "Philippines", -1)
const _hoisted_200 = /*#__PURE__*/_createElementVNode("option", { value: "Pitcairn Island" }, "Pitcairn Island", -1)
const _hoisted_201 = /*#__PURE__*/_createElementVNode("option", { value: "Poland" }, "Poland", -1)
const _hoisted_202 = /*#__PURE__*/_createElementVNode("option", { value: "Portugal" }, "Portugal", -1)
const _hoisted_203 = /*#__PURE__*/_createElementVNode("option", { value: "Puerto Rico" }, "Puerto Rico", -1)
const _hoisted_204 = /*#__PURE__*/_createElementVNode("option", { value: "Qatar" }, "Qatar", -1)
const _hoisted_205 = /*#__PURE__*/_createElementVNode("option", { value: "Republic of Montenegro" }, "Republic of Montenegro", -1)
const _hoisted_206 = /*#__PURE__*/_createElementVNode("option", { value: "Republic of Serbia" }, "Republic of Serbia", -1)
const _hoisted_207 = /*#__PURE__*/_createElementVNode("option", { value: "Reunion" }, "Reunion", -1)
const _hoisted_208 = /*#__PURE__*/_createElementVNode("option", { value: "Romania" }, "Romania", -1)
const _hoisted_209 = /*#__PURE__*/_createElementVNode("option", { value: "Russia" }, "Russia", -1)
const _hoisted_210 = /*#__PURE__*/_createElementVNode("option", { value: "Rwanda" }, "Rwanda", -1)
const _hoisted_211 = /*#__PURE__*/_createElementVNode("option", { value: "St Barthelemy" }, "St Barthelemy", -1)
const _hoisted_212 = /*#__PURE__*/_createElementVNode("option", { value: "St Eustatius" }, "St Eustatius", -1)
const _hoisted_213 = /*#__PURE__*/_createElementVNode("option", { value: "St Helena" }, "St Helena", -1)
const _hoisted_214 = /*#__PURE__*/_createElementVNode("option", { value: "St Kitts-Nevis" }, "St Kitts-Nevis", -1)
const _hoisted_215 = /*#__PURE__*/_createElementVNode("option", { value: "St Lucia" }, "St Lucia", -1)
const _hoisted_216 = /*#__PURE__*/_createElementVNode("option", { value: "St Maarten" }, "St Maarten", -1)
const _hoisted_217 = /*#__PURE__*/_createElementVNode("option", { value: "St Pierre & Miquelon" }, "St Pierre & Miquelon", -1)
const _hoisted_218 = /*#__PURE__*/_createElementVNode("option", { value: "St Vincent & Grenadines" }, "St Vincent & Grenadines", -1)
const _hoisted_219 = /*#__PURE__*/_createElementVNode("option", { value: "Saipan" }, "Saipan", -1)
const _hoisted_220 = /*#__PURE__*/_createElementVNode("option", { value: "Samoa" }, "Samoa", -1)
const _hoisted_221 = /*#__PURE__*/_createElementVNode("option", { value: "Samoa American" }, "Samoa American", -1)
const _hoisted_222 = /*#__PURE__*/_createElementVNode("option", { value: "San Marino" }, "San Marino", -1)
const _hoisted_223 = /*#__PURE__*/_createElementVNode("option", { value: "Sao Tome & Principe" }, "Sao Tome & Principe", -1)
const _hoisted_224 = /*#__PURE__*/_createElementVNode("option", { value: "Saudi Arabia" }, "Saudi Arabia", -1)
const _hoisted_225 = /*#__PURE__*/_createElementVNode("option", { value: "Senegal" }, "Senegal", -1)
const _hoisted_226 = /*#__PURE__*/_createElementVNode("option", { value: "Seychelles" }, "Seychelles", -1)
const _hoisted_227 = /*#__PURE__*/_createElementVNode("option", { value: "Sierra Leone" }, "Sierra Leone", -1)
const _hoisted_228 = /*#__PURE__*/_createElementVNode("option", { value: "Singapore" }, "Singapore", -1)
const _hoisted_229 = /*#__PURE__*/_createElementVNode("option", { value: "Slovakia" }, "Slovakia", -1)
const _hoisted_230 = /*#__PURE__*/_createElementVNode("option", { value: "Slovenia" }, "Slovenia", -1)
const _hoisted_231 = /*#__PURE__*/_createElementVNode("option", { value: "Solomon Islands" }, "Solomon Islands", -1)
const _hoisted_232 = /*#__PURE__*/_createElementVNode("option", { value: "Somalia" }, "Somalia", -1)
const _hoisted_233 = /*#__PURE__*/_createElementVNode("option", { value: "South Africa" }, "South Africa", -1)
const _hoisted_234 = /*#__PURE__*/_createElementVNode("option", { value: "Spain" }, "Spain", -1)
const _hoisted_235 = /*#__PURE__*/_createElementVNode("option", { value: "Sri Lanka" }, "Sri Lanka", -1)
const _hoisted_236 = /*#__PURE__*/_createElementVNode("option", { value: "Sudan" }, "Sudan", -1)
const _hoisted_237 = /*#__PURE__*/_createElementVNode("option", { value: "Suriname" }, "Suriname", -1)
const _hoisted_238 = /*#__PURE__*/_createElementVNode("option", { value: "Swaziland" }, "Swaziland", -1)
const _hoisted_239 = /*#__PURE__*/_createElementVNode("option", { value: "Sweden" }, "Sweden", -1)
const _hoisted_240 = /*#__PURE__*/_createElementVNode("option", { value: "Switzerland" }, "Switzerland", -1)
const _hoisted_241 = /*#__PURE__*/_createElementVNode("option", { value: "Syria" }, "Syria", -1)
const _hoisted_242 = /*#__PURE__*/_createElementVNode("option", { value: "Tahiti" }, "Tahiti", -1)
const _hoisted_243 = /*#__PURE__*/_createElementVNode("option", { value: "Taiwan" }, "Taiwan", -1)
const _hoisted_244 = /*#__PURE__*/_createElementVNode("option", { value: "Tajikistan" }, "Tajikistan", -1)
const _hoisted_245 = /*#__PURE__*/_createElementVNode("option", { value: "Tanzania" }, "Tanzania", -1)
const _hoisted_246 = /*#__PURE__*/_createElementVNode("option", { value: "Thailand" }, "Thailand", -1)
const _hoisted_247 = /*#__PURE__*/_createElementVNode("option", { value: "Togo" }, "Togo", -1)
const _hoisted_248 = /*#__PURE__*/_createElementVNode("option", { value: "Tokelau" }, "Tokelau", -1)
const _hoisted_249 = /*#__PURE__*/_createElementVNode("option", { value: "Tonga" }, "Tonga", -1)
const _hoisted_250 = /*#__PURE__*/_createElementVNode("option", { value: "Trinidad & Tobago" }, "Trinidad & Tobago", -1)
const _hoisted_251 = /*#__PURE__*/_createElementVNode("option", { value: "Tunisia" }, "Tunisia", -1)
const _hoisted_252 = /*#__PURE__*/_createElementVNode("option", { value: "Turkey" }, "Turkey", -1)
const _hoisted_253 = /*#__PURE__*/_createElementVNode("option", { value: "Turkmenistan" }, "Turkmenistan", -1)
const _hoisted_254 = /*#__PURE__*/_createElementVNode("option", { value: "Turks & Caicos Is" }, "Turks & Caicos Is", -1)
const _hoisted_255 = /*#__PURE__*/_createElementVNode("option", { value: "Tuvalu" }, "Tuvalu", -1)
const _hoisted_256 = /*#__PURE__*/_createElementVNode("option", { value: "Uganda" }, "Uganda", -1)
const _hoisted_257 = /*#__PURE__*/_createElementVNode("option", { value: "United Kingdom" }, "United Kingdom", -1)
const _hoisted_258 = /*#__PURE__*/_createElementVNode("option", { value: "Ukraine" }, "Ukraine", -1)
const _hoisted_259 = /*#__PURE__*/_createElementVNode("option", { value: "United Arab Erimates" }, "United Arab Emirates", -1)
const _hoisted_260 = /*#__PURE__*/_createElementVNode("option", { value: "United States of America" }, "United States of America", -1)
const _hoisted_261 = /*#__PURE__*/_createElementVNode("option", { value: "Uraguay" }, "Uruguay", -1)
const _hoisted_262 = /*#__PURE__*/_createElementVNode("option", { value: "Uzbekistan" }, "Uzbekistan", -1)
const _hoisted_263 = /*#__PURE__*/_createElementVNode("option", { value: "Vanuatu" }, "Vanuatu", -1)
const _hoisted_264 = /*#__PURE__*/_createElementVNode("option", { value: "Vatican City State" }, "Vatican City State", -1)
const _hoisted_265 = /*#__PURE__*/_createElementVNode("option", { value: "Venezuela" }, "Venezuela", -1)
const _hoisted_266 = /*#__PURE__*/_createElementVNode("option", { value: "Vietnam" }, "Vietnam", -1)
const _hoisted_267 = /*#__PURE__*/_createElementVNode("option", { value: "Virgin Islands (Brit)" }, "Virgin Islands (Brit)", -1)
const _hoisted_268 = /*#__PURE__*/_createElementVNode("option", { value: "Virgin Islands (USA)" }, "Virgin Islands (USA)", -1)
const _hoisted_269 = /*#__PURE__*/_createElementVNode("option", { value: "Wake Island" }, "Wake Island", -1)
const _hoisted_270 = /*#__PURE__*/_createElementVNode("option", { value: "Wallis & Futana Is" }, "Wallis & Futana Is", -1)
const _hoisted_271 = /*#__PURE__*/_createElementVNode("option", { value: "Yemen" }, "Yemen", -1)
const _hoisted_272 = /*#__PURE__*/_createElementVNode("option", { value: "Zaire" }, "Zaire", -1)
const _hoisted_273 = /*#__PURE__*/_createElementVNode("option", { value: "Zambia" }, "Zambia", -1)
const _hoisted_274 = /*#__PURE__*/_createElementVNode("option", { value: "Zimbabwe" }, "Zimbabwe", -1)
const _hoisted_275 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38,
  _hoisted_39,
  _hoisted_40,
  _hoisted_41,
  _hoisted_42,
  _hoisted_43,
  _hoisted_44,
  _hoisted_45,
  _hoisted_46,
  _hoisted_47,
  _hoisted_48,
  _hoisted_49,
  _hoisted_50,
  _hoisted_51,
  _hoisted_52,
  _hoisted_53,
  _hoisted_54,
  _hoisted_55,
  _hoisted_56,
  _hoisted_57,
  _hoisted_58,
  _hoisted_59,
  _hoisted_60,
  _hoisted_61,
  _hoisted_62,
  _hoisted_63,
  _hoisted_64,
  _hoisted_65,
  _hoisted_66,
  _hoisted_67,
  _hoisted_68,
  _hoisted_69,
  _hoisted_70,
  _hoisted_71,
  _hoisted_72,
  _hoisted_73,
  _hoisted_74,
  _hoisted_75,
  _hoisted_76,
  _hoisted_77,
  _hoisted_78,
  _hoisted_79,
  _hoisted_80,
  _hoisted_81,
  _hoisted_82,
  _hoisted_83,
  _hoisted_84,
  _hoisted_85,
  _hoisted_86,
  _hoisted_87,
  _hoisted_88,
  _hoisted_89,
  _hoisted_90,
  _hoisted_91,
  _hoisted_92,
  _hoisted_93,
  _hoisted_94,
  _hoisted_95,
  _hoisted_96,
  _hoisted_97,
  _hoisted_98,
  _hoisted_99,
  _hoisted_100,
  _hoisted_101,
  _hoisted_102,
  _hoisted_103,
  _hoisted_104,
  _hoisted_105,
  _hoisted_106,
  _hoisted_107,
  _hoisted_108,
  _hoisted_109,
  _hoisted_110,
  _hoisted_111,
  _hoisted_112,
  _hoisted_113,
  _hoisted_114,
  _hoisted_115,
  _hoisted_116,
  _hoisted_117,
  _hoisted_118,
  _hoisted_119,
  _hoisted_120,
  _hoisted_121,
  _hoisted_122,
  _hoisted_123,
  _hoisted_124,
  _hoisted_125,
  _hoisted_126,
  _hoisted_127,
  _hoisted_128,
  _hoisted_129,
  _hoisted_130,
  _hoisted_131,
  _hoisted_132,
  _hoisted_133,
  _hoisted_134,
  _hoisted_135,
  _hoisted_136,
  _hoisted_137,
  _hoisted_138,
  _hoisted_139,
  _hoisted_140,
  _hoisted_141,
  _hoisted_142,
  _hoisted_143,
  _hoisted_144,
  _hoisted_145,
  _hoisted_146,
  _hoisted_147,
  _hoisted_148,
  _hoisted_149,
  _hoisted_150,
  _hoisted_151,
  _hoisted_152,
  _hoisted_153,
  _hoisted_154,
  _hoisted_155,
  _hoisted_156,
  _hoisted_157,
  _hoisted_158,
  _hoisted_159,
  _hoisted_160,
  _hoisted_161,
  _hoisted_162,
  _hoisted_163,
  _hoisted_164,
  _hoisted_165,
  _hoisted_166,
  _hoisted_167,
  _hoisted_168,
  _hoisted_169,
  _hoisted_170,
  _hoisted_171,
  _hoisted_172,
  _hoisted_173,
  _hoisted_174,
  _hoisted_175,
  _hoisted_176,
  _hoisted_177,
  _hoisted_178,
  _hoisted_179,
  _hoisted_180,
  _hoisted_181,
  _hoisted_182,
  _hoisted_183,
  _hoisted_184,
  _hoisted_185,
  _hoisted_186,
  _hoisted_187,
  _hoisted_188,
  _hoisted_189,
  _hoisted_190,
  _hoisted_191,
  _hoisted_192,
  _hoisted_193,
  _hoisted_194,
  _hoisted_195,
  _hoisted_196,
  _hoisted_197,
  _hoisted_198,
  _hoisted_199,
  _hoisted_200,
  _hoisted_201,
  _hoisted_202,
  _hoisted_203,
  _hoisted_204,
  _hoisted_205,
  _hoisted_206,
  _hoisted_207,
  _hoisted_208,
  _hoisted_209,
  _hoisted_210,
  _hoisted_211,
  _hoisted_212,
  _hoisted_213,
  _hoisted_214,
  _hoisted_215,
  _hoisted_216,
  _hoisted_217,
  _hoisted_218,
  _hoisted_219,
  _hoisted_220,
  _hoisted_221,
  _hoisted_222,
  _hoisted_223,
  _hoisted_224,
  _hoisted_225,
  _hoisted_226,
  _hoisted_227,
  _hoisted_228,
  _hoisted_229,
  _hoisted_230,
  _hoisted_231,
  _hoisted_232,
  _hoisted_233,
  _hoisted_234,
  _hoisted_235,
  _hoisted_236,
  _hoisted_237,
  _hoisted_238,
  _hoisted_239,
  _hoisted_240,
  _hoisted_241,
  _hoisted_242,
  _hoisted_243,
  _hoisted_244,
  _hoisted_245,
  _hoisted_246,
  _hoisted_247,
  _hoisted_248,
  _hoisted_249,
  _hoisted_250,
  _hoisted_251,
  _hoisted_252,
  _hoisted_253,
  _hoisted_254,
  _hoisted_255,
  _hoisted_256,
  _hoisted_257,
  _hoisted_258,
  _hoisted_259,
  _hoisted_260,
  _hoisted_261,
  _hoisted_262,
  _hoisted_263,
  _hoisted_264,
  _hoisted_265,
  _hoisted_266,
  _hoisted_267,
  _hoisted_268,
  _hoisted_269,
  _hoisted_270,
  _hoisted_271,
  _hoisted_272,
  _hoisted_273,
  _hoisted_274
]
const _hoisted_276 = /*#__PURE__*/_createElementVNode("label", {
  for: "message",
  class: "sr-only"
}, "Message", -1)

import { ref, computed } from "vue";
import { MailIcon, PhoneIcon } from "@heroicons/vue/outline/esm/index.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'Contact',
  setup(__props) {

let form = ref({ country: "", name: "", email: "", message: "" });

let validForm = computed(() => {
  return form.value.name && form.value.email;
});

let sent = ref(false);
let sending = ref(false);

const submitForm = () => {
  // console.log(form.value);
  sending.value = true;
  fetch("/api/contact", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ message: form.value }),
  })
    .then((res) => res.json())
    .then(() => {
      // console.log(data);
      sent.value = true;
      sending.value = false;
    })
    .catch((err) => {
      console.log(err);
      sending.value = false;
      sent.value = false;
    });
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_DefaultLayout = _resolveComponent("DefaultLayout")!

  return (_openBlock(), _createBlock(_component_DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("dl", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("dd", _hoisted_12, [
                    _createVNode(_unref(PhoneIcon), {
                      class: "flex-shrink-0 h-6 w-6 text-gray-400",
                      "aria-hidden": "true"
                    }),
                    _hoisted_13,
                    _createTextVNode(" "),
                    _hoisted_14
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("dd", _hoisted_17, [
                    _createVNode(_unref(MailIcon), {
                      class: "flex-shrink-0 h-6 w-6 text-gray-400",
                      "aria-hidden": "true"
                    }),
                    _hoisted_18
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("form", {
                onSubmit: _withModifiers(submitForm, ["prevent"]),
                class: "grid grid-cols-1 gap-y-6"
              }, [
                _createElementVNode("div", null, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event)),
                    type: "text",
                    name: "full-name",
                    id: "full-name",
                    autocomplete: "name",
                    class: "block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-teal-500 focus:border-teal-500 border-gray-300 rounded-md",
                    placeholder: "Full name"
                  }, null, 512), [
                    [_vModelText, _unref(form).name]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_23,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).email) = $event)),
                    id: "email",
                    name: "email",
                    type: "email",
                    autocomplete: "email",
                    class: "block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-teal-500 focus:border-teal-500 border-gray-300 rounded-md",
                    placeholder: "Email"
                  }, null, 512), [
                    [_vModelText, _unref(form).email]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_24,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).phone) = $event)),
                    type: "text",
                    name: "phone",
                    id: "phone",
                    autocomplete: "tel",
                    class: "block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-teal-500 focus:border-teal-500 border-gray-300 rounded-md",
                    placeholder: "Phone"
                  }, null, 512), [
                    [_vModelText, _unref(form).phone]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_25,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).country) = $event)),
                    id: "country",
                    name: "country",
                    placeholder: "Country",
                    class: "block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-teal-500 focus:border-teal-500 border-gray-300 rounded-md"
                  }, _hoisted_275, 512), [
                    [_vModelSelect, _unref(form).country]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_276,
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).message) = $event)),
                    id: "message",
                    name: "message",
                    rows: "4",
                    class: "block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-teal-500 focus:border-teal-500 border border-gray-300 rounded-md",
                    placeholder: "Message"
                  }, null, 512), [
                    [_vModelText, _unref(form).message]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_Button, {
                    class: "mt-6",
                    disabled: !_unref(validForm) || _unref(sending) || _unref(sent),
                    loading: _unref(sending),
                    label: _unref(sent) ? '✔️ Sent' : 'Send',
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (submitForm()))
                  }, null, 8, ["disabled", "loading", "label"])
                ])
              ], 40, _hoisted_21)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})